import { apiFetch } from "../../lib/api";

export type MeResponse = {
  uid: string;
  role: "user" | "owner" | "admin" | "dpo";
};

export async function fetchMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>("/me", { auth: true });
}
